import React from 'react';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';

import AnimatedSection from '../AnimatedSection';

export default function KeyIngredients() {
  const ingredients = [
    {
      name: 'Shilajit',
      description: 'A potent resin known for boosting energy levels, and overall wellness.',
      imgSrc: '/images/ingredients/shilajit.png',
    },
    {
      name: 'Ashwagandha',
      description: 'An adaptogenic herb that reduces stress, supports daily balance, and improves focus.',
      imgSrc: '/images/ingredients/ashwagandha.png',
    },
    {
      name: 'Safed Musli',
      description: 'Renowned for its aphrodisiac properties and ability to combat physical weakness.',
      imgSrc: '/images/ingredients/safed_musli.png',
    },
    // {
    //   name: 'Gokshura',
    //   description: 'Helps in building muscle strength and promoting healthy reproductive function.',
    //   imgSrc: '/images/ingredients/gokshura.png',
    // },
    // {
    //   name: 'Shatavari',
    //   description: 'Supports the immune system and works synergistically to balance the body.',
    //   imgSrc: '/images/ingredients/shatavari.png',
    // },
    // {
    //   name: 'Kaunch Beej',
    //   description: 'Enhances endurance, mood, and supports healthy nerve function naturally.',
    //   imgSrc: '/images/ingredients/kaunch_beej.png',
    // }
  ];

  return (
    <section id="key-ingredients" className="cs_gray_bg_2">
      <Spacing lg="120" md="80" />
      <div className="container">
        <div className="text-center">
          <AnimatedSection animation="fadeUp">
            <SectionHeading 
              title="Premium Ayurvedic Ingredients" 
              subTitle="The Science of Nature" 
            />
          </AnimatedSection>
        </div>
        <Spacing lg="60" md="40" />
        <div className="row">
          {ingredients.map((item, index) => {
            return (
              <div className="col-lg-4 col-md-6 mb-4" key={index}>
                <AnimatedSection animation="fadeUp" delay={index * 0.1} className="h-100">
                  <div 
                    className="cs_iconbox cs_style_2 cs_radius_15" 
                    style={{
                      background: '#fff', 
                      padding: '40px 30px', 
                      textAlign: 'center',
                      boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                      height: '100%',
                      transition: 'all 0.3s ease',
                      border: '1px solid rgba(0,0,0,0.03)'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(104, 224, 207, 0.15)';
                      e.currentTarget.style.borderColor = 'rgba(104, 224, 207, 0.3)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.05)';
                      e.currentTarget.style.borderColor = 'rgba(0,0,0,0.03)';
                    }}
                  >
                    <div className="mb-4 mx-auto" style={{
                      width: '100px',
                      height: '100px',
                      borderRadius: '50%',
                      overflow: 'hidden',
                      boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                      border: '3px solid #fff'
                    }}>
                      <img src={item.imgSrc} alt={item.name} className="w-100 h-100" style={{ objectFit: 'cover' }} />
                    </div>
                    <h3 className="cs_iconbox_title cs_fs_24 cs_semibold mb-3">{item.name}</h3>
                    <p className="cs_iconbox_subtitle mb-0">{item.description}</p>
                  </div>
                </AnimatedSection>
              </div>
            );
          })}
        </div>
      </div>
      <Spacing lg="120" md="80" />
    </section>
  );
}
